/**
 * ValidationSummary — Publish-time error list with "Fix →" links
 *
 * Displayed when the user tries to publish and there are validation errors.
 * Each error links to the relevant step/section in the editor.
 */

import React from 'react';

export default function ValidationSummary({ errors, onNavigate, onDismiss }) {
  if (!errors || errors.length === 0) return null;

  return (
    <div className="config-validation-summary">
      <div className="config-validation-header">
        <span>Fix {errors.length} issue{errors.length !== 1 ? 's' : ''} before publishing</span>
        {onDismiss && (
          <button type="button" className="btn btn-ghost btn-sm" onClick={onDismiss}>✕</button>
        )}
      </div>
      <ul className="config-validation-list">
        {errors.map((err, i) => (
          <li key={i} className="config-validation-item">
            <span className="config-validation-message">{err.message}</span>
            {onNavigate && (
              <button
                type="button"
                className="config-validation-link"
                onClick={() => onNavigate(err.processIndex, err.stepIndex, err.field)}
              >
                {err.action || 'Fix it'} →
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
